import { SetUserLimitsAction } from '@portal/actions/limits';
import { GET_LIMITS, UPDATE_LIMIT_STATUS } from '~/actions/actionTypes';

const initialState: reducers.TransactionLimitReducer = {
  list: [],
  status: null,
  error: null,
};
const limitReducer = (state = initialState, action: SetUserLimitsAction) => {
  const { type, payload } = action;
  switch (type) {
    case GET_LIMITS:
      if (!Array.isArray(payload)) {
        return state;
      }
      state = {
        ...state,
        list: payload,
      };
      break;

    case UPDATE_LIMIT_STATUS: {
      return {
        ...state,
        status: payload,
      };
    }
    default:
      return state;
  }
  return state;
};
export default limitReducer;
